import { Component } from "react";
import * as React from "react";
import {SubjectItem} from "./pages/onboard/OnboardSubjectMergePage/SubjectItem";
import SubjectMergeCard from "./pages/onboard/SubjectMergeCard";
import {SubjectExcludes} from "../models/SchoolWorkloadConfig";
import SdsSubject from "../models/SdsSubject";
import {Dictionary} from "lodash";
import * as _ from "lodash";
import {SubjectMerge} from "../models/SubjectMerge";

interface SubjectMergeEditorProps {
    sdsSubjects: SdsSubject[];
    subjectExcludes?: SubjectExcludes | null; // null if loaded but does not exist
    
    subjectMerges: SubjectMerge[];
    
    onMergesChanged(subjectMerges: SubjectMerge[]): void;
}

interface SubjectMergeEditorState {
    sdsSubjectDict?: Dictionary<SdsSubject>;
    subjectItems?: SubjectItem[];
    selectedSubjectItem?: SubjectItem;
    subjectItemBeingDragged?: SubjectItem;
}

export default class SubjectMergeEditor extends Component<SubjectMergeEditorProps, SubjectMergeEditorState>
{
    public static calcSubjectItemsFromConfigAndSdsSubjects(subjectMerges: SubjectMerge[],subjectExcludes: SubjectExcludes | null,subjectCodeSdsSubjectDict: Dictionary<SdsSubject>): SubjectItem[]
    {
        let codesAlreadyInMerges: string[] = [];
        subjectMerges.forEach((subjectMerge) => {
            codesAlreadyInMerges.push(subjectMerge.targetSubjectCode)
            codesAlreadyInMerges.push(...subjectMerge.sourceSubjectCodes);
        });
        codesAlreadyInMerges = codesAlreadyInMerges.map(c => c.toLowerCase());

        const subjectMergeItems = subjectMerges.map(subjectMerge => SubjectItem.fromSubjectMerge(subjectMerge,subjectCodeSdsSubjectDict));

        const unmergedItems = _.values(subjectCodeSdsSubjectDict).filter(sdsSubject => {
            return codesAlreadyInMerges.indexOf(sdsSubject.subjectCode.toLowerCase()) === -1;
        })
            .map(sdsSubject => SubjectItem.fromSdsSubject(sdsSubject));

        let subjectMergedCombined = [...subjectMergeItems, ...unmergedItems];
        
        if(subjectExcludes !== null)
        {
            const excludedCodes = subjectExcludes.sourceSubjectCodes.map(c => c.toLowerCase());
            
            subjectMergedCombined = subjectMergedCombined.filter((subjectItem) => {
                
                return !_.includes(excludedCodes,subjectItem.code.toLowerCase());
            });
        }
        
        return subjectMergedCombined;
    }
    
    constructor(props: Readonly<SubjectMergeEditorProps>) {
        super(props);
        this.state = {
            sdsSubjectDict: undefined,
            subjectItems: undefined,
            selectedSubjectItem: undefined,
            subjectItemBeingDragged: undefined
        }
    }

    componentDidUpdate(prevProps: Readonly<SubjectMergeEditorProps>, prevState: Readonly<SubjectMergeEditorState>, snapshot?: any)
    {
        if (this.props.subjectMerges !== prevProps.subjectMerges || this.props.subjectExcludes !== prevProps.subjectExcludes || this.props.sdsSubjects !== prevProps.sdsSubjects)
        {
            this.setSubjectItems();
        }
    }

    public componentDidMount()
    {
        this.setSubjectItems()
    }

    private setSubjectItems() : void
    {
        if(!this.props.subjectMerges || this.props.subjectExcludes === undefined)
        {
            return;
        }

        const sdsSubjectDict = _.keyBy(this.props.sdsSubjects,"subjectCode");
        const subjectItems = SubjectMergeEditor.calcSubjectItemsFromConfigAndSdsSubjects(this.props.subjectMerges,this.props.subjectExcludes,sdsSubjectDict);

        this.setState({
            subjectItems,
            sdsSubjectDict,
        });
    }

    private performMerge(itemMergingInto: SubjectItem,itemToMerge: SubjectItem): void
    {
        if(this.state.subjectItems === undefined)
        {
            return;
        }
        
        const newMergedItem = SubjectItem.merge(itemMergingInto,itemToMerge);
        
        const newSubjectItems = [...this.state.subjectItems];
        
        const indexOfClicked = newSubjectItems.indexOf(itemMergingInto);
        newSubjectItems.splice(indexOfClicked,1);

        const indexOfSelected = newSubjectItems.indexOf(itemToMerge);
        newSubjectItems.splice(indexOfSelected,1);

        const sortedNewItems = _.sortBy(newSubjectItems,["name"]);

        sortedNewItems.splice(indexOfClicked,0,newMergedItem);
        
        this.setState({
            selectedSubjectItem: undefined
        });

        this.mergesHaveChanged(sortedNewItems);
    }

    private onUnmergeSubjectCode = (subjectItem: SubjectItem, subjectCodeToUnmerge: string): void => {

        if(this.state.subjectItems === undefined)
        {
            return;
        }
        
        const newSubjectItems = [...this.state.subjectItems];
        
        const indexOfItem = newSubjectItems.indexOf(subjectItem);
        newSubjectItems.splice(indexOfItem,1);

        const {updatedItem,newItem} = SubjectItem.split(subjectItem,subjectCodeToUnmerge,this.state.sdsSubjectDict!);

        newSubjectItems.push(newItem);

        const sortedNewSubjectItems = _.sortBy(newSubjectItems,["name"]);
        sortedNewSubjectItems.splice(indexOfItem,0,updatedItem);

        this.mergesHaveChanged(sortedNewSubjectItems);
    }

    private onMergeClicked = (subjectItemClicked: SubjectItem) => {
        if(this.state.selectedSubjectItem === undefined)
        {
            this.setState({
                selectedSubjectItem: subjectItemClicked
            });
        }
        else if(this.state.selectedSubjectItem === subjectItemClicked)
        {
            this.setState({
                selectedSubjectItem: undefined
            });
        }
        else
        {
            this.performMerge(subjectItemClicked,this.state.selectedSubjectItem);
        }
    }
    
    private onDrag = (subjectItemBeingDragged: SubjectItem) => {
        console.log(`Started dragging ${subjectItemBeingDragged.name}`);
        this.setState({
            subjectItemBeingDragged
        });
    }

    private onDrop = (subjectItemDroppedOn: SubjectItem) => {
        console.log(`Dropped on to ${subjectItemDroppedOn.name}`);
        if(this.state.subjectItemBeingDragged && this.state.subjectItemBeingDragged !== subjectItemDroppedOn)
        {
            this.performMerge(subjectItemDroppedOn,this.state.subjectItemBeingDragged);
        }
    }
    
    private mergesHaveChanged(newSubjectItems: SubjectItem[])
    {
        const filteredSubjectMerges = newSubjectItems
            .filter(si => si.containsMerges())
            .map(si => si.toSubjectMerge())
            .filter(sm => //don't keep new merges that are empty as they have no value
            { 
                if(sm.isNew)
                {
                    if(sm.sourceSubjectCodes.length === 0)
                    {
                        return false;
                    }
                    if(sm.sourceSubjectCodes.length === 1 && sm.sourceSubjectCodes[0] === sm.targetSubjectCode)
                    {
                        return false;
                    }
                }
                
                return true;
            });
        
        console.log("Subject Merges have changed to :  ");
        console.log(filteredSubjectMerges);
        this.props.onMergesChanged(filteredSubjectMerges);
    }
    
    public render() {
        
        const subjectItems = this.state.subjectItems || [];
        
        let subjectMergeCards = subjectItems.sort(SubjectItem.AlphabeticalCompare)
            .map((subjectItem: SubjectItem,index: number) => {
                return <SubjectMergeCard key={index} subjectItem={subjectItem} selected={this.state.selectedSubjectItem === subjectItem} onMergeClicked={this.onMergeClicked} onDrag={this.onDrag} onDrop={this.onDrop} onUnmergeSubjectCode={this.onUnmergeSubjectCode}/>;
            });
        
        return (
            <div className={"flex-row flex--flow-wrap flex--justify-content-center "}>
                {subjectMergeCards}
            </div>
        );
    }
}